import { Route } from 'types/route.type';
import Settings from './settings';

export const routes: Route[] = [
  {
    path: '/settings',
    component: Settings,
    id: 'sidebar.settings',
  },
];
